import { tsInitVueGrid } from '../js-utils'
import SentMailGrid from '../vue-components/sent-mail-grid.vue'

document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('body.admin-sent-mail-messages')) {
    const gridEl = document.querySelector('[data-is="SentMailGrid"]')
    if (gridEl instanceof HTMLElement) {
      window.sentMessagesGrid = tsInitVueGrid(SentMailGrid, gridEl)
    }
  }
})
